import {useState} from "react";
import Tooltip from "@mui/material/Tooltip";
import { Zoom } from "@mui/material";
import DeleteQuestionModal from  "../../modals/DeleteQuestionModal.jsx";


let newindex = '';

function InterpretiveQuestionsRenderer({
  questions,
  handleScenarioQuestionChange,
  handleScenarioAnswerChange,
  handlescenarioQuestionsEdit,
  handleScenarioAnswersEdit,
  handleScenarioQuestionDelete,
}) {
  let totalQuestion = 1;
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  
  
  const handleDeleteClick = (index) => {    
    setShowDeleteModal(true);
    newindex = index + 1;
  };

    // Handler for confirming delete
  const handleConfirmDelete = () => {
    handleScenarioQuestionDelete(newindex - 1);
  };
  return (
    <>
      {questions.map((scenarioQuestion, index) => (
        <div
          key={index}
          className="mb-4 h-auto  border-slate-100 hover:border-[#f4833d] border-2 hover:border-dotted rounded question-answer-container p-4"
        >
          <div className="flex place-content-between">
            <p className="flex">
              <span>{totalQuestion++}.&nbsp; </span>{" "}
              {scenarioQuestion.editing ? (
                <div
                  contentEditable
                  id={`question-${index}`}
                  className=""
                  onBlur={(e) => {
                    handleScenarioQuestionChange(
                      index,
                      e.target.textContent
                    );
                    handlescenarioQuestionsEdit(index);
                  }}
                  dangerouslySetInnerHTML={{
                    __html: scenarioQuestion.Question,
                  }}
                />
              ) : (
                <span
                  onClick={() => handlescenarioQuestionsEdit(index)}
                  className="cursor-pointer"
                  dangerouslySetInnerHTML={{
                    __html: scenarioQuestion.Question,
                  }}
                />
              )}
            </p>
            <div className="flex edit-delete-icons">
              <Tooltip
                title="Edit"
                arrow
                placement="top"
                TransitionComponent={Zoom}
                TransitionProps={{ timeout: 300 }}
              >
                <button
                  onClick={() => handlescenarioQuestionsEdit(index)}
                  className="text-indigo-500 mr-2"
                >
                  <i className="fa-solid fa-pen-to-square"></i>{" "}
                </button>
              </Tooltip>

              <Tooltip
                title="Delete"
                arrow
                placement="top"
                TransitionComponent={Zoom}
                TransitionProps={{ timeout: 300 }}
              >
                <button
                  onClick={()=>handleDeleteClick(index)}
                  className="text-red-500"
                >
                  <i className="fa-solid fa-trash"></i>{" "}
                </button>
              </Tooltip>
            </div>
          </div>
          <div>
            <p className="font-bold">Answer Source:</p>{" "}
            {scenarioQuestion.editingAnswer ? (
              <div
                contentEditable
                className="editable-answer"
                onBlur={(e) => {
                  handleScenarioAnswerChange(index, e.target.textContent);
                  handleScenarioAnswersEdit(index);
                }}
                dangerouslySetInnerHTML={{
                  __html: scenarioQuestion.Answer,
                }}
              />
            ) : (
              <span
                onClick={() => handleScenarioAnswersEdit(index)}
                className="cursor-pointer"
                dangerouslySetInnerHTML={{
                  __html: scenarioQuestion.Answer,
                }}
              />
            )}
          </div>
        </div>
      ))}
      <DeleteQuestionModal
                      open={showDeleteModal}
                      onClose={() => setShowDeleteModal(false)}
                      onConfirmDelete={handleConfirmDelete}
                      questionNumber={newindex}
                    />
    </>
  );
}

export default InterpretiveQuestionsRenderer;
